/* eslint-disable react/jsx-props-no-spreading */
/** @jsx jsx */
import { forwardRef, useMemo } from 'react';
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import merge from 'deepmerge';

import { Input, dlsGray01Bg } from '@americanexpress/dls-react';
import styleObject from '../../../../styles/EnhancedDataTable/EnhancedTableFilter/datePicker';

import DateIconButton from './DateIconButton';

const DatePickerInput = forwardRef(({
  calendarClosed,
  id,
  inputRef,
  onButtonClick,
  value,
  calendarButtonLabel,
  dateIconFilled,
  isDisable,
  ...otherProps
}, ref) => {
  const inputTheme = useMemo(() => {
    const inputStyling = {
      ...styleObject.datePicker__formControl_iconHover_input,
      borderRight: 'none',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      ...dlsGray01Bg,
      ...{},
    };
    return merge.all([
      styleObject.datePicker__formControl_iconHover,
      { input: inputStyling },
    ]);
  }, []);

  return (
    <Input
      id={id}
      theme={inputTheme}
      value={value}
      disabled={true}
      readOnly={true}
      {...otherProps}
    >
      <DateIconButton
        label={calendarButtonLabel}
        iconFilled={dateIconFilled}
        onClick={onButtonClick}
        ref={ref}
        id={id}
        isDisable={isDisable}
      />
    </Input>
  );
});

DatePickerInput.displayName = 'DatePickerInput';

DatePickerInput.propTypes = {
  /* Whether calendar is closed or not */
  calendarClosed: PropTypes.bool.isRequired,
  /* Triggered when icon button clicked */
  onButtonClick: PropTypes.func.isRequired,
  /* The label of the button to open the calendar and switch dates */
  calendarButtonLabel: PropTypes.string.isRequired,
  /* If true, the DateIcon is filled. */
  dateIconFilled: PropTypes.bool.isRequired,
};

export default DatePickerInput;
